// Shared dialogs and delegated triggers survive Horizon's cart/variant replacements.
(() => {
  if (window.neobayPolicyDialogReady) return;
  window.neobayPolicyDialogReady = true;

  const bound = new WeakSet();
  function bind(dialog) {
    if (bound.has(dialog)) return;
    bound.add(dialog);
    dialog.querySelectorAll('.ta-policy-dialog__body table').forEach((table) => {
      const heading = table.previousElementSibling;
      const scroller = document.createElement('div');
      scroller.className = 'ta-policy-dialog__table-scroll';
      scroller.tabIndex = 0;
      scroller.setAttribute('role', 'region');
      if (heading?.matches('h2, h3, h4')) scroller.setAttribute('aria-label', heading.textContent.trim());
      table.before(scroller);
      scroller.append(table);
    });
    // Keep clicks and Escape inside this modal from closing the parent cart drawer.
    dialog.addEventListener('click', (event) => {
      event.stopPropagation();
      if (event.target.closest('[data-policy-close]')) {
        dialog.close();
      } else if (event.target === dialog) {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) {
          dialog.close();
        }
      }
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      event.stopPropagation();
      dialog.close();
    });
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      event.stopPropagation();
      dialog.close();
    });
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-policy-dialog]');
    if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const dialog = document.getElementById(trigger.dataset.policyDialog);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    if (dialog.open) return;
    bind(dialog);

    const home = dialog.parentNode;
    const next = dialog.nextSibling;
    const parentDialog = trigger.closest('dialog[open]');
    // Horizon traps focus inside its drawer. Nest temporarily while the policy is open.
    if (parentDialog) parentDialog.append(dialog);
    dialog.addEventListener('close', () => {
      if (dialog.parentNode !== home) home.insertBefore(dialog, next?.parentNode === home ? next : null);
      if (trigger.isConnected) trigger.focus({ preventScroll: true });
    }, { once: true });
    dialog.showModal();
    const body = dialog.querySelector('.ta-policy-dialog__body');
    if (body) body.scrollTop = 0;
  });
})();
